import { SEO } from "@/components/SEO";
import { VisionBookHero } from "../components/site/vision-book-workshop/VisionBookHero";
import { MaybeThisSoundsFamiliar } from "../components/site/vision-book-workshop/MaybeThisSoundsFamiliar";
import { WhyItWorks } from "../components/site/vision-book-workshop/WhyItWorks";
import { ADifferentKindOfVisionBook } from "../components/site/vision-book-workshop/ADifferentKindOfVisionBook";
import { YourVisionBook } from "../components/site/vision-book-workshop/YourVisionBook";
import { WorkshopOptions } from "../components/site/vision-book-workshop/WorkshopOptions";
import { FinalCTA } from "../components/site/vision-book-workshop/FinalCTA";

export default function VisionBookWorkshop() {
  return (
    <div data-testid="vision-book-workshop-page">
      <SEO
        title="Vision Book Workshop"
        description="A place to hear yourself again. The Vision Book Workshop creates space to recognize your future when it whispers, before life gets loud again."
        path="/work-with-me/vision-book-workshop"
      />
      <VisionBookHero />
      <MaybeThisSoundsFamiliar />
      <WhyItWorks />
      <ADifferentKindOfVisionBook />
      <YourVisionBook />
      <WorkshopOptions />
      <FinalCTA />
    </div>
  );
}
